import { Project, project } from '@/db/schema/project'
import { User, user } from '@/db/schema/user'
import { relations } from 'drizzle-orm'
import { index, integer, pgEnum, pgTable, serial, text, timestamp } from 'drizzle-orm/pg-core'

export const accountType = pgEnum('account_type', ['main', 'expense', 'salary', 'deposit', 'cashout'])

export const account = pgTable(
  'account',
  {
    id: serial('id').primaryKey(),
    migrationId: text('migration_id'), // Migration ID
    created: timestamp().defaultNow().notNull(),
    updated: timestamp().defaultNow().notNull(),
    name: text().notNull(),
    type: accountType().notNull(),
  },
  (t) => ({
    typeIdx: index('account_type_idx').on(t.type),
  })
)

export type Account = typeof account.$inferSelect & { balance?: number }
export type AccountResolved = Account & { project?: Project | null; user?: User | null }
export type InsertAccount = typeof account.$inferInsert
export type UpdateAccount = Partial<Account>

export const userAccount = pgTable('user_account', {
  accountId: integer('account_id')
    .references(() => account.id, { onDelete: 'cascade' })
    .unique()
    .notNull(),
  userId: integer('user_id')
    .references(() => user.id, { onDelete: 'cascade' })
    .notNull(),
})

export const userAccountRelation = relations(user, ({ many }) => ({
  accounts: many(userAccount),
}))
export const accountUserRelation = relations(account, ({ one }) => ({
  user: one(userAccount),
}))

export const accountUserRelations = relations(userAccount, ({ one }) => ({
  user: one(user, {
    fields: [userAccount.userId],
    references: [user.id],
  }),
  account: one(account, {
    fields: [userAccount.userId],
    references: [account.id],
  }),
}))

export const projectAccount = pgTable('project_account', {
  accountId: integer('account_id')
    .references(() => account.id, { onDelete: 'cascade' })
    .unique()
    .notNull(),
  projectId: integer('project_id')
    .references(() => project.id, { onDelete: 'cascade' })
    .notNull(),
})
